import PaperItem from "@components/Paper/PaperItem";
import type { PortService } from "@services/port-services/types";
import { t } from "i18next";

const TEST_ID_BASE = "port-services-preview";
const DEBUNKERING_CATEGORY = "De-bunkering";
const wrapperStyleClass = "border-b border-[#F1F2F4] pb-3";
const wrapperLastStyleClass = "pb-0";
const transStyleClass = "font-normal text-[#646A77]";

type DebunkeringFieldsProps = {
  langBase: string;
  portServiceDetails: PortService;
};

type DebunkeringField = {
  key: string;
  labelKey: string;
  value?: string | number;
};

export const isDebunkeringPortService = (serviceCategory?: string) =>
  serviceCategory === DEBUNKERING_CATEGORY;

const formatValue = (value?: string | number) => value || "-";

const DebunkeringFields: React.FC<DebunkeringFieldsProps> = ({ langBase, portServiceDetails }) => {
  const fields: DebunkeringField[] = [
    {
      key: "bunker-barge-imo",
      labelKey: "bunker-barge-imo",
      value: portServiceDetails.bunkerBargeIMO,
    },

    {
      key: "bunker-barge-name",
      labelKey: "bunker-barge-name",
      value: portServiceDetails.bunkerBargeName,
    },
    {
      key: "quantity",
      labelKey: "quantity",
      value: portServiceDetails.quantity,
    },
    {
      key: "debunkering-type",
      labelKey: "debunkering-type",
      value: portServiceDetails.bunkeringType,
    },
    {
      key: "unit-of-measurement",
      labelKey: "unit-of-measurement",
      value: portServiceDetails.unitOfMeasurement,
    },
    {
      key: "debunkering-company-name",
      labelKey: "debunkering-company-name",
      value: portServiceDetails.bunkeringCompanyName,
    },
  ];

  return (
    <>
      {fields.map(({ key, labelKey, value }, index) => (
        <PaperItem
          key={key}
          testId={`${TEST_ID_BASE}-${key}`}
          translate={t(`${langBase}.${labelKey}`)}
          textStyles="font-medium"
          tranStyle={transStyleClass}
          wrapperStyle={index === fields.length - 1 ? wrapperLastStyleClass : wrapperStyleClass}
          text={formatValue(value)}
        />
      ))}
    </>
  );
};

export default DebunkeringFields;
